<template>
  <div>
    <vxe-card>
      <vxe-button content="button.return" icon="vxe-icon-arrows-left" mode="text" status="primary" @click="back"/>
    </vxe-card>
    <inspection-config ref="inspectionConfig" :inspection-types="inspectionTypes"/>
    <picking-mode-config ref="pickingModeConfig" :order-properties="orderProperties" :picking-modes="pickingModes"/>
    <automation-config ref="automationConfig" :pickup-modes="pickupModes" :regions="regions"/>
    <distribution-container-config ref="distributionContainerConfig" :container-types="containerTypes" :distribution-types="distributionTypes" :flow-types="flowTypes" :pack-types="packTypes"/>
    <conveyor-config ref="conveyorConfig" :conveyors="conveyors" :directions="directions" :pickup-modes="pickupModes"/>
    <seeding-position-config ref="seedingPositionConfig" :position-types="positionTypes"/>
    <packing-position-config ref="packingPositionConfig" :position-types="positionTypes"/>
  </div>
</template>

<script>
import InspectionConfig from '@/views/basedata/warehouse/InspectionConfig.vue'
import PickingModeConfig from '@/views/basedata/warehouse/PickingModeConfig.vue'
import AutomationConfig from '@/views/basedata/warehouse/AutomationConfig.vue'
import DistributionContainerConfig from '@/views/basedata/warehouse/DistributionContainerConfig.vue'
import ConveyorConfig from '@/views/basedata/warehouse/ConveyorConfig.vue'
import SeedingPositionConfig from '@/views/basedata/warehouse/SeedingPositionConfig.vue'
import PackingPositionConfig from '@/views/basedata/warehouse/PackingPositionConfig.vue'

export default {
  components: { AutomationConfig, ConveyorConfig, DistributionContainerConfig, InspectionConfig, PackingPositionConfig, PickingModeConfig, SeedingPositionConfig },
  props: {
    pickupModes: { type: Array, default: [] },
    regions: { type: Array, default: [] },
    orderProperties: { type: Array, default: [] },
    inspectionTypes: { type: Array, default: [] },
    pickingModes: { type: Array, default: [] },
    flowTypes: { type: Array, default: [] },
    packTypes: { type: Array, default: [] },
    distributionTypes: { type: Array, default: [] },
    containerTypes: { type: Array, default: [] },
    conveyors: { type: Array, default: [] },
    directions: { type: Array, default: [] },
    positionTypes: { type: Array, default: [] }
  },
  methods: {
    back() {
      this.$emit('back')
    },
    refresh(warehouse) {
      this.$refs.inspectionConfig.refresh(warehouse)
      this.$refs.pickingModeConfig.refresh(warehouse)
      this.$refs.automationConfig.refresh(warehouse)
      this.$refs.distributionContainerConfig.refresh(warehouse)
      this.$refs.conveyorConfig.refresh(warehouse)
      this.$refs.seedingPositionConfig.refresh(warehouse)
      this.$refs.packingPositionConfig.refresh(warehouse)
    }
  }
}
</script>